module.exports = __webpack_public_path__ + "static/media/truffle.836d08d8.svg";